import * as pkijs from "pkijs";
import * as asn1js from "asn1js";

export type CertificateSubjectData = { c: string; st: string; l: string; o: string; cn: string };

// Builds an X.509 Name with one attribute per RDN (C=.., ST=.., ...), the conventional
// layout that MDMs and certificate validators expect.
//
// pkijs's RelativeDistinguishedNames.toSchema() wraps every typesAndValues entry in a single
// SET, which encodes a multi-valued RDN (shown by OpenSSL as "C=GB + ST=London + ...").
// Encoding the SEQUENCE OF SET ourselves and decoding it back makes pkijs keep these bytes
// (valueBeforeDecode) when the certificate is serialised and signed. Treat the returned name
// as immutable: later changes to its typesAndValues are not reflected in the encoding.
export const buildCertificateSubject = (subjectData: CertificateSubjectData): pkijs.RelativeDistinguishedNames => {
  const attributes: [string, string, typeof asn1js.PrintableString | typeof asn1js.Utf8String][] = [
    ["2.5.4.6", subjectData.c, asn1js.PrintableString],
    ["2.5.4.8", subjectData.st, asn1js.Utf8String],
    ["2.5.4.7", subjectData.l, asn1js.Utf8String],
    ["2.5.4.10", subjectData.o, asn1js.Utf8String],
    ["2.5.4.3", subjectData.cn, asn1js.Utf8String],
  ];
  const typesAndValues = attributes
    .filter(([, value]) => value)
    .map(
      ([type, value, StringType]) =>
        new pkijs.AttributeTypeAndValue({
          type,
          value: new StringType({ value }) as unknown as pkijs.AttributeValueType,
        })
    );
  const name = new asn1js.Sequence({
    value: typesAndValues.map((attribute) => new asn1js.Set({ value: [attribute.toSchema()] })),
  });
  return pkijs.RelativeDistinguishedNames.fromBER(name.toBER(false));
};
